"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _inline_svg = require("./inline_svg.utils");

var _inline_svg2 = _interopRequireDefault(require("./inline_svg.proptypes"));

var _excluded = ["fontsize", "themeColor"];

var EventSeat = function EventSeat(props) {
  var theme = _react.default.useContext(_styledComponents.ThemeContext);

  var fontsize = props.fontsize,
      themeColor = props.themeColor,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _parseStyles = (0, _inline_svg.parseStyles)({
    fontsize: fontsize,
    themeColor: themeColor
  }, theme),
      sizeStyles = _parseStyles.sizeStyles,
      colorStyles = _parseStyles.colorStyles;

  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, sizeStyles, {
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react.default.createElement("path", (0, _extends2.default)({
    // eslint-disable-next-line max-len
    d: "M0.833496 11.7693V8.1026H11.1668V11.7693H10.1668V9.10259H1.83346V11.7693H0.833496ZM1.16758 7.21797C0.936313 7.21797 0.739485 7.13703 0.577096 6.97515C0.414696 6.81326 0.333496 6.61668 0.333496 6.3854C0.333496 6.15414 0.41444 5.95731 0.576329 5.79492C0.738218 5.63253 0.934796 5.55134 1.16606 5.55134C1.39734 5.55134 1.59417 5.63228 1.75656 5.79417C1.91895 5.95606 2.00015 6.15264 2.00015 6.3839C2.00015 6.61517 1.9192 6.812 1.75731 6.97439C1.59542 7.13678 1.39885 7.21797 1.16758 7.21797ZM2.92325 7.17952V1.4744C2.92325 1.14299 3.04125 0.859287 3.27725 0.623287C3.51325 0.387287 3.79695 0.269287 4.12836 0.269287H7.87193C8.20334 0.269287 8.48705 0.387287 8.72305 0.623287C8.95905 0.859287 9.07705 1.14299 9.07705 1.4744V7.17952H2.92325ZM10.8342 7.21797C10.6029 7.21797 10.4061 7.13703 10.2437 6.97515C10.0813 6.81326 10.0001 6.61668 10.0001 6.3854C10.0001 6.15414 10.0811 5.95731 10.243 5.79492C10.4049 5.63253 10.6014 5.55134 10.8327 5.55134C11.064 5.55134 11.2608 5.63228 11.4232 5.79417C11.5856 5.95606 11.6668 6.15264 11.6668 6.3839C11.6668 6.61517 11.5859 6.812 11.424 6.97439C11.2621 7.13678 11.0655 7.21797 10.8342 7.21797ZM3.92321 6.17954H8.07708V1.4744C8.07708 1.41457 8.05785 1.36542 8.01938 1.32695C7.98091 1.2885 7.93176 1.26927 7.87193 1.26927H4.12836C4.06853 1.26927 4.01938 1.2885 3.98091 1.32695C3.94245 1.36542 3.92321 1.41457 3.92321 1.4744V6.17954Z",
    fill: "#4B4FA6"
  }, colorStyles)));
};

EventSeat.propTypes = _inline_svg2.default.propTypes;
EventSeat.defaultProps = _inline_svg2.default.defaultProps;
var _default = EventSeat;
exports.default = _default;